export function editDistance(a, b) {
  const m = a.length;
  const n = b.length;
  const d = new Uint32Array((m + 1) * (n + 1));

  for (let i = 1; i <= m; i++) {
    set(i, 0, i);
  }

  for (let j = 1; j <= n; j++) {
    set(0, j, j);
  }

  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      const cost = a.charAt(i - 1) !== b.charAt(j - 1) ? 1 : 0;
      const x = get(i - 1, j) + 1;
      const y = get(i, j - 1) + 1;
      const z = get(i - 1, j - 1) + cost;
      set(i, j, Math.min(x, y, z));
    }
  }

  return get(m, n);

  function set(i, j, k) {
    d[i * (m + 1) + j] = k;
  }

  function get(i, j) {
    return d[i * (m + 1) + j];
  }
}
